// import axios from 'axios';
// import moment from 'moment';
// import jwt from 'jwt-simple';
// import {ROOT_URL} from '../../config'; //SOCIAL_KEY

// import {axios} from '../common/index';
import { FacebookAuthProvider, GoogleAuthProvider, OAuthProvider, signInWithEmailAndPassword, signInWithPopup, createUserWithEmailAndPassword, updateProfile, onIdTokenChanged } from 'firebase/auth'; //signInWithRedirect
import { signOut, setPersistence, browserLocalPersistence } from 'firebase/auth';
import get from 'lodash/get';
import {
    AUTH_USER, AUTH_ERROR, DEAUTH, DETECT_WARNING_MACHINE, SIGNUP, SIGNUP_ERR, INITIATE_SIGNIN,
    SET_FB_RESPONSE,
    CHANGE_PASSWORD, CHANGE_PASSWORD_ERR,
    REQUEST_FORGOT_PASSWORD, REQUEST_FORGOT_PASSWORD_ERR,
    UPDATE_FORGOT_PASSWORD, UPDATE_FORGOT_PASSWORD_ERR,
    REGISTER_DEVICE, SHOW_PDPA_POPUP, HIDE_PDPA_POPUP, PDPA_CONSENT_ERROR, PDPA_CONSENT_SUCCESS
} from '../auth/type';
import { load } from '../common';
import { GET_PROFILE } from '../profile/type';
import FingerPrint2 from 'fingerprintjs2';
import { getErrorCode } from '../../assets/util';
import { setActiveLanguage } from 'react-localize-redux';
import { isServer } from '../../store';
import { auth } from '../../assets/firebase';
import { updatePassword } from 'firebase/auth';
import { swal, close } from 'react-redux-sweetalert';
// function tokenForId(content) {
//     const timestamp = new Date().getTime();
//     //sub: subject, iat: issued at time
//     return jwt.encode({ sub: content, iat: timestamp }, SOCIAL_KEY);
// }

export function detectDevice() {
    return (dispatch, getState, { axios }) => {
        if (!isServer) {
            FingerPrint2().get((secret, component) => {
                axios.post(`/api/device_auth`, {
                    device_secret: secret
                })
                    .then((response) => {
                        dispatch({
                            type: DETECT_WARNING_MACHINE,
                            payload: response.data
                        })
                    })
                    .catch((error) => {
                        dispatch({
                            type: DETECT_WARNING_MACHINE,
                            payload: true
                        })
                    });
            });
        } else {
            dispatch({
                type: DETECT_WARNING_MACHINE,
                payload: false
            })
        }
    }
}

export function registerDevice() {
    return (dispatch, getState, { axNL }) => {
        return new Promise((resolve, reject) => {
            if (!isServer) {
                FingerPrint2().get((secret, component) => {
                    dispatch({
                        type: REGISTER_DEVICE,
                        payload: { secret, components: component },
                    })
                    axNL.post('/api/device', {
                        secret: secret,
                        components: component,
                    })
                        .then(res => resolve(res))
                        .catch(err => reject(err))
                });
            } else {
                resolve(null)
            }
        })
    }
}

export function signinWithCookiePromise() {
    return (dispatch, getState, { axios, axNL }) => {
        return new Promise(resolve => {
            axNL.get(`/profile`)
                .then((response) => {
                    dispatch({
                        type: AUTH_USER,
                        payload: { profile: response.data.profile }
                    });
                    dispatch({
                        type: GET_PROFILE,
                        payload: response.data.profile
                    });
                    const setting = response.data.setting || null;
                    let langSetting = setting.web_lang || 'th';
                    dispatch(setActiveLanguage(langSetting));

                    // Check PDPA consent after successful login
                    const profile = response.data.profile;
                    if (profile && profile.pdpa_consented === false) {
                        dispatch(showPDPAPopup());
                    }

                    resolve();
                })
                .catch((error) => {
                    resolve();
                })
        })
    }
}
export function signinWithCookie(token = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: INITIATE_SIGNIN,
            payload: null,
        })
        let params = {}
        if (token) {
            params.token = token
        }
        axios.get(`/profile`, {
            params
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: { profile: response.data.profile }
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                const setting = response.data.setting || null;
                let langSetting = setting.web_lang || 'th';
                dispatch(setActiveLanguage(langSetting));
                dispatch({
                    type: INITIATE_SIGNIN,
                    payload: true,
                })
            })
            .catch((error) => {
                dispatch({
                    type: INITIATE_SIGNIN,
                    payload: true,
                })
            })
    }
}
export function signin(email, password, keep, captchaResponse) {
    return (dispatch, getState, { axios }) => {
        FingerPrint2().get((secret, component) => {
            axios.post(`/signin`, {
                email, password, captchaResponse, secret
            })
                .then((response) => {
                    // localStorage.setItem("token", response.data.token);
                    localStorage.setItem("profile", JSON.stringify(response.data.profile));
                    if (keep) {
                        // localStorage.setItem("token_keep", response.data.token);
                        localStorage.setItem("profile_keep", JSON.stringify(response.data.profile));
                    }
                    dispatch({
                        type: AUTH_USER,
                        payload: response.data
                    });
                    dispatch({
                        type: DETECT_WARNING_MACHINE,
                        payload: false
                    });
                    dispatch({
                        type: GET_PROFILE,
                        payload: response.data.profile
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: AUTH_ERROR,
                        payload: typeof error.response.data === "undefined" ? "Some error has occured. Please try again later." : error.response.data.message
                    });

                    if (error.response.data.suspicious) {
                        dispatch({
                            type: DETECT_WARNING_MACHINE,
                            payload: error.response.data.suspicious
                        });
                    }
                });
        });
    }
}

export function accessTokenVerify(accessToken) {
    return (dispatch, getState, { axios }) => {
        axios.post(`/v3/auth/accesstoken/verify`, {
            token: accessToken,
        })
            .then((response) => {
                // localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                // localStorage.setItem("profile_keep", JSON.stringify(response.data.profile));
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: false
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });

                // Check PDPA consent after successful login
                const profile = response.data.profile;
                if (profile && profile.pdpa_consented === false) {
                    dispatch(showPDPAPopup());
                }
            })
            .catch((error) => {
                dispatch({
                    type: AUTH_ERROR,
                    payload: typeof error.response.data === "undefined" ? "Some error has occured. Please try again later." : error.response.data.message
                });

                if (error.response.data.suspicious) {
                    dispatch({
                        type: DETECT_WARNING_MACHINE,
                        payload: error.response.data.suspicious
                    });
                }
            });
    }
}

export function fbSignin(accessToken, fbUserID) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: AUTH_ERROR,
            payload: ""
        });

        axios.post(`/auth/facebook`, { //signin_fb
            // "username": signedRequest, 
            // "password": token
            access_token: accessToken
        })
            .then((response) => {
                // localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                localStorage.setItem("fb_auth", fbUserID);
                // localStorage.setItem("token_keep", response.data.token);
                // localStorage.setItem("profile_keep", JSON.stringify(response.data.profile));
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
            })
            .catch((error) => {
                dispatch({
                    type: AUTH_ERROR,
                    payload: error.response.data.message
                });
            });
    }
}

export function signup(email, password, first_name, last_name, email_consent, fbResponse) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SIGNUP,
            payload: null,
        });
        dispatch({
            type: SIGNUP_ERR,
            payload: null
        })
        axios.post(`/signup`, {
            email, password, first_name, last_name, email_consent, fbResponse
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: false
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                dispatch({
                    type: SIGNUP,
                    payload: true,
                });
            })
            .catch((error) => {
                dispatch({
                    type: SIGNUP_ERR,
                    payload: error.response ? (error.response.data ? error.response.data.code : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE",
                });
                dispatch({
                    type: SIGNUP,
                    payload: false,
                });
            })
    }
}

export function signUpWithFirebase({ accessToken, first_name, last_name, email_consent, ...rest }) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SIGNUP,
            payload: null,
        });
        dispatch({
            type: SIGNUP_ERR,
            payload: null
        })
        axios.post(`/v3/auth/signup`, {
            first_name, last_name, email_consent, ...rest
        }, {
            headers: {
                "authorization": accessToken,
            }
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: false
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                dispatch({
                    type: SIGNUP,
                    payload: true,
                });
            })
            .catch((error) => {
                dispatch({
                    type: SIGNUP_ERR,
                    payload: { error: { code: get(error, "response.data.code", "CODE_UNAVAILABLE"), message: get(error, "response.data.message", 'Something went wrong.') } }, // error.response ? (error.response.data ? error.response.data.code : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE",
                });
                dispatch({
                    type: SIGNUP,
                    payload: false,
                });
            })
    }
}

export function signupWithProfile(email, password, profile) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SIGNUP,
            payload: null,
        });
        dispatch({
            type: SIGNUP_ERR,
            payload: null
        })
        axios.post(`/signup`, {
            email, password, profile
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: false
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                dispatch({
                    type: SIGNUP,
                    payload: true,
                });
            })
            .catch((error) => {
                dispatch({
                    type: SIGNUP_ERR,
                    payload: error.response ? (error.response.data ? error.response.data.code : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE",
                });
                dispatch({
                    type: SIGNUP,
                    payload: false,
                });
            })
    }
}
export function signout() {
    return (dispatch, getState, { axios }) => {
        signOut(auth).then(() => {
            axios.post(`/v3/auth/signout`)
                .then((response) => {
                    localStorage.clear();
                    dispatch({
                        type: DEAUTH
                    });
                })
                .catch((error) => {
                    localStorage.clear();
                    dispatch({
                        type: DEAUTH
                    });
                })
        });
    }
}

export function setFbResponse(fbResponse) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SET_FB_RESPONSE,
            payload: fbResponse
        })
    }
}

export function changePassword(newPassword) {
    return (dispatch) => {
        dispatch({
            type: CHANGE_PASSWORD,
            payload: null
        });
        updatePassword(auth.currentUser, newPassword)
            .then(() => {
                dispatch({
                    type: CHANGE_PASSWORD,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: CHANGE_PASSWORD_ERR,
                    payload: error
                });
            })
        // axios.post(`/changePassword`, {
        //     oldPassword, newPassword
        // }, {
        //     headers: {
        //         authorization: localStorage.getItem('token')
        //     }
        // })
        //     .then((response) => {
        //         dispatch({
        //             type: CHANGE_PASSWORD,
        //             payload: true
        //         });
        //     })
        //     .catch((error) => {
        //         const err_code = getErrorCode(error);
        //         dispatch({
        //             type: CHANGE_PASSWORD_ERR,
        //             payload: err_code
        //         });
        //     })
    }
}

export function forgotPasswordRequest(email) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: REQUEST_FORGOT_PASSWORD,
            payload: null
        });
        axios.post(`/forgot_password`, {
            email
        })
            .then((response) => {
                dispatch({
                    type: REQUEST_FORGOT_PASSWORD,
                    payload: true
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: REQUEST_FORGOT_PASSWORD_ERR,
                    payload: err_code
                });
            })
    }
}
export function updateForgotPassword(token, password) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: UPDATE_FORGOT_PASSWORD,
            payload: null
        });
        axios.post(`/update_forgot_password`, {
            token, password
        })
            .then((response) => {
                dispatch({
                    type: UPDATE_FORGOT_PASSWORD,
                    payload: true
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: UPDATE_FORGOT_PASSWORD_ERR,
                    payload: err_code
                });
            })
    }
}
export function firebaseSigninUsernameAndPassword(username, password) {
    return async (dispatch, getState, { axios }) => {
        dispatch(load(true));
        try {
            localStorage.removeItem('token');
            await setPersistence(auth, browserLocalPersistence);
            const userCredential = await signInWithEmailAndPassword(auth, username, password);
            // Automatically refresh the access token when it's about to expire
            onIdTokenChanged(auth, (user) => {
                if (user) {
                    // User is signed in, and the token has been refreshed
                    const accessToken = user.accessToken;
                    localStorage.setItem("accessToken", accessToken);
                    dispatch(accessTokenVerify(accessToken));
                }
            });
            dispatch(load(false));
            const user = userCredential.user;
            dispatch(accessTokenVerify(user.accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch({
                type: 'AUTH_ERROR', //auth error,
                payload: error,
            });
        }
    }
}
export function firebaseSigninRedirect(type) {
    return async (dispatch, getState, { axios }) => {
        dispatch(load(true));
        localStorage.removeItem('token');
        let provider;
        switch (type) {
            case 'facebook':
                provider = new FacebookAuthProvider(); break;
            case 'google':
                provider = new GoogleAuthProvider(); break;
            case 'apple':
                provider = new OAuthProvider('apple.com'); break;
            default:
                break;
        }
        if (!provider) {
            throw Error({ message: 'provider is not defined' });
        }
        provider.addScope('email');
        await setPersistence(auth, browserLocalPersistence);
        // return signInWithRedirect(auth, provider);
        try {
            let userCred = await signInWithPopup(auth, provider);
            onIdTokenChanged(auth, (user) => {
                if (user) {
                    // User is signed in, and the token has been refreshed
                    const accessToken = user.accessToken;
                    localStorage.setItem("accessToken", accessToken);
                    dispatch(accessTokenVerify(accessToken));
                }
            });
            dispatch(getCredFromPopup(userCred));
        } catch (error) {
            dispatch(load(false));
            let text = get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`);
            if (error.code === 'auth/account-exists-with-different-credential') {
                text = 'พบอีเมลล์เดิมของลูกค้าสมัครโดยใช้วิธีอ่ื่น กรุณาใช้วิธีเดิมในการเข้าสู่ระบบค่ะ';
            }
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: text,
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        }
    }
}
export function firebaseSignup({ email, password, first_name, last_name, email_consent, ...rest }) {
    return async (dispatch, getState, { axios }) => {
        try {
            dispatch(load(true));
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const accessToken = userCredential.user.accessToken;
            const displayName = first_name.trim() + ((last_name && last_name.trim() !== '' ? ' ' + last_name : ''));
            await updateProfile(userCredential.user, { displayName: displayName });
            dispatch(load(false));
            dispatch(signUpWithFirebase({ accessToken, first_name, last_name, email_consent }));
        } catch (error) {
            dispatch(load(false));
            dispatch({
                type: SIGNUP_ERR,
                payload: error,
            });
        }
    }
}

export function getCredFromPopup(result) {
    return async (dispatch, getState, { axios }) => {
        try {
            if (!result) {
                dispatch(load(false));
                return;
            }
            const user = result.user;
            const accessToken = user.accessToken;

            dispatch(load(false));
            dispatch(accessTokenVerify(accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`),
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        }
    }
}

export function getRedirectFromProvider(result) {
    return async (dispatch, getState, { axios }) => {
        try {
            if (!result) {
                dispatch(load(false));
                return;
            }
            const user = result.user;
            const accessToken = user.accessToken;
            dispatch(load(false));
            dispatch(accessTokenVerify(accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`),
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        }
    }
}

// PDPA Consent Actions
export function showPDPAPopup() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SHOW_PDPA_POPUP,
            payload: true
        });
    }
}

export function hidePDPAPopup() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: HIDE_PDPA_POPUP,
            payload: false
        });
    }
}

export function submitPDPAConsent() {
    return (dispatch, getState, { axios }) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: PDPA_CONSENT_SUCCESS,
                payload: null
            });

            axios.post('/v3/users/me/pdpa/consent')
                .then((response) => {
                    dispatch({
                        type: PDPA_CONSENT_SUCCESS,
                        payload: true
                    });
                    dispatch(hidePDPAPopup());
                    resolve(response);
                })
                .catch((error) => {
                    dispatch({
                        type: PDPA_CONSENT_ERROR,
                        payload: get(error, "response.data.message", "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
                    });
                    reject(error);
                });
        });
    }
}

export function getPDPAPolicy() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise((resolve, reject) => {
            axStrapi.get('/policy-page')
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}